/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionsPost from "../../../redux/actions/artciles";
import {
  RestlessTable,
  RestlessInteractionsFormatter,
  RestlessButtonFormatter,
} from "../../../_metronic/layout/components/Table";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route } from "react-router-dom";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import { Alert } from "react-bootstrap";
import { articlesSlice } from "../../../redux/actions/artciles/articlesSlice";

const { actions } = articlesSlice;

export default function RestlessArticlesPage({ history }) {
  const dispatch = useDispatch();
  const [createdArticleSuccess, setCreatedArticleSuccess] = useState(false)
  const [updatedArticleSuccess, setUpdatedArticleSuccess] = useState(false)
  const {
    articlesList,
    listLoading,
    articleCreating,
    error,
    articleGet,
    hideLoading,
    articleHided,
    articleCreated,
    articleUpdated,
  } = useSelector((state) => ({
    articlesList: state.articles.articlesList,
    listLoading: state.articles.listLoading,
    articleCreating: state.articles.articleCreating,
    error: state.articles.error,
    hideLoading: state.articles.hideLoading,
    articleHided: state.articles.articleHided,
    articleCreated: state.articles.articleCreated,
    articleUpdated: state.articles.articleUpdated,
    articleGet: state.articles.articleGet,
  }));

  

  useEffect(() => {
    dispatch(actionsPost.fetchArticles());
    if (articleGet) {
      dispatch(actions.articleFetched({ articleGet: null }));
    }
  }, []); 

  useEffect(() => {
    if (articleCreated) {
      setCreatedArticleSuccess(true)
      dispatch(actionsPost.articleCreatedCleanState());
    }
    if (createdArticleSuccess) {
      setTimeout(() => {
        setCreatedArticleSuccess(false)
      }, 3000);
    }
  }, [articleCreated,createdArticleSuccess]);

  useEffect(() => {
    if (articleUpdated) {
      setUpdatedArticleSuccess(true)
      dispatch(actionsPost.articleEditCleanState())
    }
    if (updatedArticleSuccess) {
      setTimeout(() => {
        setUpdatedArticleSuccess(false)
      }, 3000);
    }
  }, [articleUpdated,updatedArticleSuccess]);

  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return articlesUIEvents.openArticlesEditPage(row);
      },
      icon: (
        <SVG
          title="Edit"
          src={toAbsoluteUrl("/media/svg/icons/General/Edit.svg")}
        />
      ),
      title: "Edit",
      disabled: true,
    },
    {
      onClickFunction: (row) => {
        return articlesUIEvents.openModerateArticlesDialog(row);
      },
      disabled: true,
      icon: (
        <SVG
          title="Moderate"
          src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")}
        />
      ),
      title: "Moderate",
    },
  ];
  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Author",
      sort: true,
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
    },
    {
      dataField: "deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "views_count",
      text: "Views",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "reactions",
      text: "Reactions",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "info.comments",
      text: "Comments",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "reports",
      text: "Reports",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: {
        buttonsArr,
      },
    },
  ];

  //Functions to open the dialog
  const articlesUIEvents = {
    openArticlesCreatePage: () => {
      history.push(`/articles/new`);
    },
    openArticlesEditPage: (row) => {
      history.push(`/articles/${row.id}/editor`);
    },
    openModerateArticlesDialog: (row) => {
      history.push({
        pathname: `/articles/${row.id}/moderate`,
        state: {
          row: row,
        },
      });
    },
  };

  const onSubmit = (values, row) => {
    if (values.deleteArticle) {
      dispatch(actionsPost.articleDelete(row.id));
    }
    dispatch(actionsPost.articlesHide(values));
    history.push("/articles");
  };

  const renderArticleModerationStatus = () => {
    return (
      <Alert
        variant="success"
        className="text-center"
        dismissible
        onClose={() => dispatch(actionsPost.articleCleanState())}
      >
        The article has been deleted succesfully
      </Alert>
    );
  };

  const renderArticleModerationError = () => {
    return (
      <Alert
        variant="danger"
        className="text-center"
        dismissible
        onClose={() => dispatch(actionsPost.articleCleanState())}
      >
        An error has occurred
      </Alert>
    );
  };

  const renderArticleCreated = () => {
   
    return (
      <Alert
        variant="success"
        className="text-center"
        dismissible
        onClose={() => {
          setUpdatedArticleSuccess(false)
          setCreatedArticleSuccess(false)
        }}
      >
        {createdArticleSuccess && "Article created successfully"}
        {updatedArticleSuccess && "Article updated successfully"}
      </Alert>
    );
  };

  return (
    <>
      {(listLoading && articleCreating) || hideLoading || listLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {(createdArticleSuccess || updatedArticleSuccess) && renderArticleCreated()}
          {!error && articleHided && renderArticleModerationStatus()}
          {error && !articleHided && renderArticleModerationError()}
          <Route path="/articles/:id/moderate">
            {({ history, match }) => (
              <RestlessModerationModal
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                article={true}
                onSubmit={onSubmit}
                onHide={() => {
                  history.push("/articles");
                }}
                entityType="Resource"
              />
            )}
          </Route>
          <RestlessTable
            data={articlesList || []}
            columns={columns}
            withPagination
            withNewButton
            newButton={{
              onClick: articlesUIEvents.openArticlesCreatePage,
              text: "New Resource",
            }}
          />
        </>
      )}
    </>
  );
}
